const brItem = {
  item: {
    label: {
      name: 'Nome',
      category: 'Categoria',
      description: 'Descrição',
      preset: 'É pré-definido',
      createdAt: 'Criado em',
      true: 'Sim',
      false: 'Não',
    },

    action: {
      cancel: 'Cancelar',
      add: 'Adicionar item',
      edit: 'Editar item',
      create: 'Criar item',
      delete: 'Apagar item',
      loading: 'Carregando item',
    },

    hints: {
      delete: 'Deseja mesmo apagar este item?',
      deleteWarning: 'O item será removido de todas as tabelas de preço.',
    },

    messages: {
      successfullyCreated: 'Item criado com sucesso',
      successfullyUpdated: 'Item atualizado com sucesso',
      successfullyDeleted: 'Item removido com sucesso',
    },
  },
}

export default brItem
